import React, { useEffect, useState } from 'react';
import { useStore } from '../Context';
import SignCanvas from '../components/SignCanvas';
import Navigation from '../components/Navigation/Navigation';
import signs from '../services/signs';
import loanlogs from '../services/loanlogs';
import cuotitasstores from '../services/cuotitasstores';
import { GESTURES } from '../constants';
import moment from 'moment';

const ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || 'production';
const DIRNAME_SIGNATURES = process.env.REACT_APP_S3_DIRNAME_SIGNATURES || `${ENVIRONMENT}/cuotitas/signatures`

function DigitalSign() {
    const { setSignCanvas, canvasUri, openModal, requestId, photoUri, loading, setLoading, hash, dni, faceliveness_validation, faceLivenessImageUrl } = useStore();
    const gesture = GESTURES[photoUri.randomSelfie]
    const from = moment().format('MM-DD-YYYY hh:mm:ss.SSSS A');
    const [cleared, setCleared] = useState(false);
    const [screen, setScreen] = useState(false);
    /* state to store stroke length */
    const [strokeLength, setStrokeLength] = useState(0);

    window.onresize = changeScreen;

    function changeScreen() {
        setScreen(!screen);
    }

    function onSignatureChange (signature) {
        if (signature) {
            setCleared(false);
            setSignCanvas(signature);
        }
    };

    function clear () {
        setCleared(true);
        setSignCanvas(null);
    };

    async function handleSubmit () {
        if (!canvasUri || loading) return;
        if (strokeLength<1000){
            openModal({ type: 'retrySignature',  backdrop: 'static'});
            clear()
            return;
        }
        setLoading(true);

        const digitalSignUrl = await cuotitasstores.uploadS3({
            fileUri: canvasUri,
            filename: `${requestId}-signature.png`,
            dirname: DIRNAME_SIGNATURES,
        })

        let selfie1;
        let selfie2;

        if (faceliveness_validation) {
            if (!faceLivenessImageUrl) {
                setLoading(false);
                openModal({ type: 'retry', message: 'No hay imagen de Face Liveness para firmar. Volvé al paso anterior o reiniciá el proceso.' });
                return;
            }
            selfie1 = faceLivenessImageUrl;
        } else {
            selfie1 = await cuotitasstores.uploadS3({
                fileUri: photoUri.neutralSelfie,
                filename: `${hash}-${dni}-${from}-SN.jpg`,
                dirname: 'selfie',
            });
            selfie2 = await cuotitasstores.uploadS3({
                fileUri: photoUri.specialSelfie,
                filename: `${hash}-${dni}-${from}-${gesture.type}.jpg`,
                dirname: 'selfie',
            });
        }

        const data = {
            selfie1,
            ...(selfie2 && { selfie2 }),
            signature: digitalSignUrl
        };

        signs.postSignature(requestId, data)
            .then(() => {
                openModal({ type: 'success',  backdrop: 'static'});
                setLoading(false);
            })
            .catch(error => {
                openModal({ type: 'retry', message: error.message });
                setLoading(false);
            });
    };

    useEffect(() => {
        loanlogs.success('/sign').catch(console.log)
    }, []);

    return (
        <main className='page-step'>
            <Navigation />
            <header className="page-header">
                <h1>Firma digital</h1>
            </header>
            <div className="page-content">
                <SignCanvas 
                    className="full-height"
                    clear={cleared} 
                    onChange={onSignatureChange} 
                    setStrokeLength={setStrokeLength}
                />
            </div>
            <div className="page-actions flex-column">
                <button className='button-primary' filled onClick={handleSubmit} disabled={!!loading}>
                    Continuar
                </button>
                <button className='button-secondary' onClick={clear} disabled={!!loading}>
                    Rehacer
                </button>
            </div>
        </main>
    );
}

export default DigitalSign;
